module.exports = __webpack_public_path__ + "static/images/styles/images/pure-table/shine-left.41b50503.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/pure-table/shine-left.png
// module id = 3682
// module chunks = 11